var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-wrap"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.name}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }